import { useScrollReveal } from '@/hooks/useScrollReveal';
import { services } from '@/mocks/stats';

export default function Services() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="services" className="w-full py-16 md:py-24 bg-charcoal-300">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div
          ref={ref}
          className={`text-center mb-10 md:mb-14 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}
        >
          <span className="inline-block text-xs md:text-sm font-semibold text-brand-orange uppercase tracking-widest mb-3">
            What We Offer
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white mb-3">
            Our Premium Services
          </h2>
          <p className="text-sm md:text-base text-ivory-300 max-w-xl mx-auto">
            Comprehensive real estate solutions designed for modern investors and property owners in Pakistan.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`group p-5 md:p-6 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 hover:border-brand-orange/40 transition-all duration-500 hover:-translate-y-1 ${
                isVisible ? 'animate-fade-in-up' : 'opacity-0'
              }`}
              style={{ animationDelay: `${0.1 + index * 0.08}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-brand-orange/20 text-brand-orange mb-4 group-hover:bg-brand-orange group-hover:text-white transition-colors duration-300">
                <i className={`${service.icon} text-xl`} />
              </div>
              <h3 className="text-base md:text-lg font-bold text-white mb-2">
                {service.title}
              </h3>
              <p className="text-sm text-ivory-300 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}